/** Sign in with Google (#149): the API's redirects and what their outcome codes mean. */

/** `link`: Vincular from Ajustes; `invite`: accept the invitation whose page was just opened. */
export const googleStartUrl = (link = false, invite = false) =>
  `/api/v1/auth/google/start${link ? "?link=true" : invite ? "?invite=true" : ""}`;

const ERRORS: Record<string, string> = {
  no_invite: "Esta cuenta no tiene invitación. Pide a quien te invitó que te envíe una.",
  taken: "Esa cuenta de Google ya está vinculada a otra persona.",
  unverified: "Tu correo de Google no está verificado.",
  cancelled: "Cancelaste el acceso con Google.",
  expired: "El acceso con Google caducó. Inténtalo de nuevo.",
  too_many: "Demasiados intentos, espera unos minutos.",
  invite_invalid: "Esta invitación no existe. Pide un enlace nuevo.",
  invite_used: "Esta invitación ya se usó. Pide un enlace nuevo.",
  invite_expired: "Tu invitación caducó o tardaste mucho. Ábrela otra vez o pide una nueva.",
  wrong_email: "Entra con la cuenta de Google del correo al que llegó la invitación.",
  already_user: "Esa cuenta de Google ya entra a SavingApp: inicia sesión con ella.",
  seat_taken: "Ese hogar ya tiene dos personas.",
};

export const googleErrorMessage = (code: string) =>
  ERRORS[code] ?? "Google no confirmó tu cuenta. Inténtalo de nuevo.";

export type GoogleOutcome = { linked: boolean; error: string | null };

/** Reads `?google=linked` / `?google_error=<code>` left by the callback, once: the params are
 * dropped from the address bar so a reload doesn't show them again. */
export function takeGoogleOutcome(): GoogleOutcome | null {
  const url = new URL(window.location.href);
  const linked = url.searchParams.get("google") === "linked";
  const code = url.searchParams.get("google_error");
  if (!linked && code === null) return null;
  url.searchParams.delete("google");
  url.searchParams.delete("google_error");
  window.history.replaceState(window.history.state, "", url.pathname + url.search + url.hash);
  return { linked, error: code === null ? null : googleErrorMessage(code) };
}

// read when the app loads, before any screen: the login screen or Ajustes takes it
let pending: GoogleOutcome | null = typeof window === "undefined" ? null : takeGoogleOutcome();

/** The outcome the app was opened with, handed out once. */
export function consumeGoogleOutcome(): GoogleOutcome | null {
  const outcome = pending;
  pending = null;
  return outcome;
}
